var render = function render(){var _vm=this,_c=_vm._self._c;return _c('k-dialog',[_c('div',{staticClass:"dialog-effect-wrapper"},[_c('img',{staticClass:"y-rotate",attrs:{"src":_vm.img}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }